// assets/es-cart-badge.js
// New 2026-07-27 (Jeff): the cart count badge (.enj-cartcount, shared by the header cart icon and
// the scroll-triggered sticky-cart icon) previously always rendered, showing a bare "0" with an
// empty cart. header-v6.liquid now renders an adjusted count (es_cart_display_count) on initial
// page load that excludes any Insurance product_type line -- the ShipInsure app auto-adds its own
// "Shipping Protection" line item to the real Shopify cart, and Jeff wants that add-on to never
// count toward the number shown on the badge, even though it should stay in the cart itself.
// header-v6.liquid can only compute that adjusted count at page-render time though, so this script
// keeps it correct afterward: the theme's own AJAX add-to-cart (cartCountSelector: '.enj-cartcount')
// overwrites the badge's text with Shopify's raw, unfiltered cart.item_count whenever the cart
// changes without a page reload -- a MutationObserver catches that overwrite and immediately
// replaces it with our own re-fetched, Insurance-excluded count instead.
(function () {
  var SUPPRESS_MS = 50;
  var suppressed = false;
  var refreshing = false;

  function isInsuranceLine(item) {
    if ((item.product_type || '').toLowerCase() === 'insurance') return true;
    var haystack = ((item.title || '') + ' ' + (item.product_title || '') + ' ' + (item.vendor || '') + ' ' + (item.handle || '')).toLowerCase();
    return /shipinsure|package protection|shipping protection/.test(haystack);
  }

  function applyCount(n) {
    var badges = document.querySelectorAll('.enj-cartcount');
    suppressed = true;
    badges.forEach(function (el) {
      el.textContent = String(n);
      el.classList.toggle('es-cart-badge--visible', n > 0);
    });
    setTimeout(function () { suppressed = false; }, SUPPRESS_MS);
  }

  function refresh() {
    if (refreshing) return;
    refreshing = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = 0;
        (cart.items || []).forEach(function (item) {
          if (!isInsuranceLine(item)) n += item.quantity;
        });
        applyCount(n);
      })
      .catch(function () {})
      .then(function () { refreshing = false; });
  }

  function init() {
    var badges = document.querySelectorAll('.enj-cartcount');
    if (!badges.length) return;
    var observer = new MutationObserver(function () {
      if (suppressed) return;
      refresh();
    });
    badges.forEach(function (el) {
      observer.observe(el, { childList: true, characterData: true, subtree: true });
    });
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
